import React, { useState, useEffect } from "react";

//component material mui
import {
  Autocomplete,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";

//icons
import DeleteIcon from "@mui/icons-material/Delete";

//config
import { enlistaArrayCodigosMensajesIdiomas } from "../../../../Actions/Generales/IdiomasAction";
import { MostrarMensaje } from "../../../../Utilidades/ManejoMensajes";
import { ValidarPropiedad } from "../../../../Utilidades/ValidarPropiedades";

//context user
import { useGlobalState } from "../../../../Utilidades/useGlobalState";

//components
import { ActionTitleAndButtons } from "../ActionTitleAndButtons";
import { MOBILE } from "../../config";

//actions
import {
  ObtenerTablaRegistros,
  CrearNuevoRegistro,
  EliminarRegistro,
} from "../../../../Actions/Clientes/ClientesPaisesAction";

//styles
import { styleTable, StyleHome } from "../../../Tool/Style";

import {
  StyledTableCellClass,
  StyledTableRowClass,
  StyledTableRowHeaderClass,
} from "../../../../theme/themeTableRow";

/**
 *
 * @param {{ DatosContactoInfo: {CodigoVerificado:boolean, ListCamposRequeridos:Array<{code:string}>},  deviceIs: "DESKTOP" | "MOBILE" | "TABLET" }} param0
 * @returns
 */
const PaisesPerfil = ({ deviceIs = "DESKTOP", DatosContactoInfo }) => {
  const {
    CodigoVerificado,
    ListCamposRequeridos,
    Credenciales,
    DatosNacionalidadInfo,
    ElimenarRegistro,
  } = DatosContactoInfo;

  const { Pais, ListPaises } = DatosNacionalidadInfo;

  const { etiquetas, codigoIdioma, dispatch } = useGlobalState();

  const [registro, setRegistro] = useState({
    id: "00000000-0000-0000-0000-000000000000",
    dsc: "",
  });

  const [paisCIF, setPaisCIF] = useState({
    CountryId:
      ListPaises.length > 0
        ? ListPaises[0].couCountryId
        : "00000000-0000-0000-0000-000000000000",
    Type: "N",
  });

  const [listPaisesCIF, setListPaisesCIF] = useState([]); // se encarga del recolectar el listado de paisesCIF

  useEffect(() => {
    if (registro.id !== "00000000-0000-0000-0000-000000000000") {
      ElimenarRegistro(registro.dsc, eliminaPais);
    }
  }, [registro.id]);

  useEffect(() => {
    LoadProperties();
  }, [codigoIdioma]);

  const LoadPaisesTable = async () => {
    const objetoListar = {
      CustomerId: Credenciales.customerId,
      UserId: Credenciales.userId,
      CompanyId: Credenciales.companyId,
    };
    const response = await ObtenerTablaRegistros(objetoListar);

    if (response.status === 200) {
      setListPaisesCIF(response.data);
    } else {
      if (response.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          response.data.errors
        );
        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
      } else {
        MostrarMensaje(dispatch, "error", [response.statusText]);
      }
      setListPaisesCIF([]);
    }
  };

  const LoadProperties = async () => {
    await LoadPaisesTable();
  };

  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target; // se desestructura del targen el nombre y el valor que trae

    // se usa el hook de useState sobre la variable de estado local y se actualiza solo la propiedad que concuerda con el
    // valor que se le envia lo demas se queda igual
    setPaisCIF((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };

  const salvarPaises = () => {
    if (paisCIF.CountryId !== "00000000-0000-0000-0000-000000000000") {
      dispatch({
        type: "LOAD_CLIENT",
        texto: etiquetas.CargandoModal.Et_Procesando,
      });

      const objetoPais = {
        CustomerId: Credenciales.customerId,
        CountryId: paisCIF.CountryId,
        Type: paisCIF.Type,
        CompanyId: Credenciales.companyId,
        UserId: Credenciales.userId,
      };

      const validacionCampos = ValidarPropiedad(
        ListCamposRequeridos,
        objetoPais,
        dispatch
      );
      if (validacionCampos) {
        CrearNuevoRegistro(objetoPais).then((response) => {
          if (response.status === 200) {
            //si la respuesta fue existosa
            LoadPaisesTable();
            NuevoPais();
            MostrarMensaje(dispatch, "success", ["insertOk"]);
          } else {
            if (response.data.errors) {
              const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
                response.data.errors
              );
              MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
            } else {
              MostrarMensaje(dispatch, "error", [response.statusText]);
            }
          }
        });
      }
      dispatch({ type: "CLOSE_LOAD_CLIENT" });
    } else {
      MostrarMensaje(dispatch, "warning", ["WarningSelectPais"]);
    }
  };

  function NuevoPais() {
    Pais.SetInfo({
      couCountryId: ListPaises[0].couCountryId,
      couName: ListPaises[0].couName,
    });
    setPaisCIF((anterior) => ({
      ...anterior,
      CountryId: ListPaises[0].couCountryId,
    }));
  }

  const eliminaPais = async () => {
    const objetoEliminar = {
      RelCountryId: registro.id,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    EliminarRegistro(objetoEliminar).then((response) => {
      if (response.status === 200) {
        //si la respuesta fue existosa
        MostrarMensaje(dispatch, "success", ["deleteOk"]);
        NuevoPais();
        LoadPaisesTable();
      } else {
        if (response.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            response.data.errors
          );
          MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
          MostrarMensaje(dispatch, "error", [response.statusText]);
        }
      }
      ElimenarRegistro("", () => {});
    });
  };

  const ingresarValoresMemoriaAuto = (event, newValue) => {
    if (newValue === null || newValue === undefined) {
      Pais.SetInfo({
        couCountryId: "00000000-0000-0000-0000-000000000000",
        couName: "",
      });
      setPaisCIF((anterior) => ({
        ...anterior,
        CountryId: "00000000-0000-0000-0000-000000000000",
      }));
    } else {
      Pais.SetInfo(newValue);
      setPaisCIF((anterior) => ({
        ...anterior,
        CountryId: newValue.couCountryId,
      }));
    }
  };

  return (
    <React.Fragment>
      <ActionTitleAndButtons
        key={"PaisesPerfil"}
        titleOption={etiquetas.InterfazNacionalidad.Et_tblCountrys}
        CodigoVerificado={CodigoVerificado}
        cleanClick={NuevoPais}
        deviceIs={deviceIs}
        saveClick={salvarPaises}
      />

      <Grid
        key="GridAddresInformation"
        container
        style={
          deviceIs == MOBILE
            ? { backgroundColor: "#fff" }
            : StyleHome.GridConteiner
        }
      >
        <Grid
          item
          xs={deviceIs == MOBILE ? 12 : 6}
          sm={6}
          md={6}
          style={StyleHome.GridItem}
        >
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              disabled={CodigoVerificado === false}
              noOptionsText={etiquetas.General.Et_tblSinOpciones}
              value={Pais.Info}
              labelId="careerId-label"
              options={ListPaises}
              onChange={ingresarValoresMemoriaAuto}
              getOptionLabel={(option) => option.couName}
              renderInput={(params) => (
                <TextField
                  {...params}
                  labelId="careerId-label"
                  label={
                    ListCamposRequeridos.some((x) => x.code === "CountryId")
                      ? etiquetas.InterfazNacionalidad.Et_SelecCountry + " *"
                      : etiquetas.InterfazNacionalidad.Et_SelecCountry
                  }
                />
              )}
            />
          </FormControl>
        </Grid>

        <Grid
          item
          xs={deviceIs == MOBILE ? 12 : 6}
          sm={6}
          md={6}
          style={StyleHome.GridItem}
        >
          <FormControl
            fullWidth
            variant="outlined"
            disabled={CodigoVerificado === false}
          >
            <InputLabel id="Type-label">
              {ListCamposRequeridos.some((x) => x.code === "Type")
                ? etiquetas.InterfazNacionalidad.Et_SelecTypeCountry + " *"
                : etiquetas.InterfazNacionalidad.Et_SelecTypeCountry}
            </InputLabel>
            <Select
              name="Type"
              value={paisCIF.Type}
              onChange={ingresarValoresMemoria}
              labelId="Type-label"
              label={
                ListCamposRequeridos.some((x) => x.code === "Type")
                  ? etiquetas.InterfazNacionalidad.Et_SelecTypeCountry + " *"
                  : etiquetas.InterfazNacionalidad.Et_SelecTypeCountry
              }
            >
              <MenuItem key={"ident-Nacionalidad"} value="N">
                {etiquetas.InterfazNacionalidad.Et_tblNacionalidad}
              </MenuItem>
              <MenuItem key={"ident-Residencia"} value="R">
                {etiquetas.InterfazNacionalidad.Et_tblRecidencia}
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={12} style={StyleHome.GridItem}>
          {deviceIs === MOBILE ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              {listPaisesCIF.length > 0
                ? listPaisesCIF.map((registro) => (
                    <div key={registro.cupRelCountryId + "mobile"}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={StyleHome.textPrimary}>
                          {etiquetas.InterfazNacionalidad.Et_tblCountry}:
                        </Typography>

                        <Typography sx={StyleHome.textSecondary}>
                          {registro.countryName}
                        </Typography>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={StyleHome.textPrimary}>
                          {etiquetas.InterfazNacionalidad.Et_tblTypeCountry}:
                        </Typography>

                        <Typography sx={StyleHome.textSecondary}>
                          {registro.cupType === "N"
                            ? etiquetas.InterfazNacionalidad.Et_tblNacionalidad
                            : etiquetas.InterfazNacionalidad.Et_tblRecidencia}
                        </Typography>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography sx={StyleHome.textPrimary}>
                          {etiquetas.General.Et_tblAcciones}:
                        </Typography>

                        <div width="10" align="center">
                          <Tooltip title={etiquetas.General.Et_tbnEliminar}>
                            <IconButton
                              style={styleTable.BodyButtoms}
                              disabled={CodigoVerificado === false}
                              onClick={() => {
                                setRegistro({
                                  id: registro.cupRelCountryId,
                                  dsc: registro.countryName,
                                });
                              }}
                            >
                              <DeleteIcon fontSize="normal" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  ))
                : null}
            </div>
          ) : (
            <TableContainer component={Grid} style={styleTable.TableConteiner}>
              <Table stickyHeader>
                <TableHead style={styleTable.TableHeader}>
                  <StyledTableRowHeaderClass>
                    <StyledTableCellClass>
                      {etiquetas.InterfazNacionalidad.Et_tblCountry}
                    </StyledTableCellClass>

                    <StyledTableCellClass>
                      {etiquetas.InterfazNacionalidad.Et_tblTypeCountry}
                    </StyledTableCellClass>

                    <StyledTableCellClass width="85px" Align="center">
                      {etiquetas.General.Et_tblAcciones}
                    </StyledTableCellClass>
                  </StyledTableRowHeaderClass>
                </TableHead>
                <TableBody>
                  {listPaisesCIF.length > 0 ? (
                    listPaisesCIF.map((registro) => (
                      <StyledTableRowClass key={registro.cupRelCountryId}>
                        <StyledTableCellClass component="th" scope="row">
                          {registro.countryName}
                        </StyledTableCellClass>

                        <StyledTableCellClass>
                          {registro.cupType === "N"
                            ? etiquetas.InterfazNacionalidad.Et_tblNacionalidad
                            : etiquetas.InterfazNacionalidad.Et_tblRecidencia}
                        </StyledTableCellClass>

                        <StyledTableCellClass width="85px" Align="center">
                          <div style={styleTable.BodyContainerButtoms}>
                            <div width="10" align="center">
                              <Tooltip title={etiquetas.General.Et_tbnEliminar}>
                                <IconButton
                                  style={styleTable.BodyButtoms}
                                  disabled={CodigoVerificado === false}
                                  onClick={() => {
                                    setRegistro({
                                      id: registro.cupRelCountryId,
                                      dsc: registro.countryName,
                                    });
                                  }}
                                >
                                  <DeleteIcon fontSize="normal" />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </div>
                        </StyledTableCellClass>
                      </StyledTableRowClass>
                    ))
                  ) : (
                    <StyledTableRowClass>
                      <StyledTableCellClass colSpan={3}>
                        {etiquetas.General.Et_tblTableEmty}
                      </StyledTableCellClass>
                    </StyledTableRowClass>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default PaisesPerfil;
